/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { apiHelpers } from 'ui-lottery/src/api/helpers';
import * as endpoints from './endpoints';

const { get, getWithAuth, postWithAuth, post } = apiHelpers(SecurityHelper);

// Reservations
export const getReservation = (resId) =>
    getWithAuth(endpoints.reservationEndpoint(resId));
export const createReservation = (res) =>
    postWithAuth(endpoints.reservationsEndpoint(), res);
export const updateReservation = (res) =>
    postWithAuth(endpoints.reservationsEndpoint(), res);

export const getReservations = (resIds) =>
    getWithAuth(endpoints.reservationsEndpoint(resIds));
export const validateUpsell = (params) =>
    postWithAuth(endpoints.upsellEndpoint(), params);
export const createReservations = (reservations, recaptchaOptions = {}) =>
    postWithAuth(endpoints.reservationsEndpoint(), {
        reservations,
        recaptcha_token: recaptchaOptions.recaptcha_token || null,
        recaptcha_version: recaptchaOptions.recaptcha_version || null,
    });

export const getPrice = (request) => postWithAuth(endpoints.priceEndpoint(), request);

export const validateReservation = (request) =>
    post(endpoints.validateEndpoint(), request);

// Pass Types
export const getPassTypes = (facilityId) => get(endpoints.passTypesEndpoint(facilityId));
export const getPassType = (passTypeId) => get(endpoints.passTypeEndpoint(passTypeId));

// Facilities
export const getFacilities = () => getWithAuth(endpoints.facilitiesEndpoint());
export const getFacility = (facilityId) =>
    getWithAuth(endpoints.facilityEndpoint(facilityId));
export const getFacilityByIdOrSlug = (facilityId) =>
    getWithAuth(endpoints.facilityByIdOrSlugEndpoint(facilityId));

// parent asset
export const getParentAsset = (id) => getWithAuth(endpoints.recarea(id));

// Inventory
export const getParentInventory = (id) => getWithAuth(endpoints.inventory(id));
